<div class="bridges-win-screen">
  <ion-text class="puzzle-win-message"
            [innerHTML]="(translationKey + '.win_dialog.text' | translate:{ duration: duration, moveCounter: moveCounter })">
  </ion-text>
</div>
